import React, { FC, useEffect, useState } from 'react'
import { Box, Text, Grid, HStack, useRadioGroup } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { RadioButtonProps } from '../radio-buttons/interfaces'
import { addAnswer, selectScenario, useSelector } from '../../state'
import { useDispatch } from 'react-redux'
import { Steps } from '../../state/interfaces'
import { getCookie } from '../../scenarios/storage'

interface Choice {
  value: string
  label: string
  image?: string
  isChecked?: boolean
}

export interface RadioButtonGroupProps {
  name: string
  choices: Choice[]
  value?: string
  onChange?: (values: string[]) => void
  component: FC<RadioButtonProps>
}

export const leadCheckavailability: FC<RadioButtonGroupProps> = ({
  choices,
  value,
  onChange,
  name,
  component: Component,
}) => {
  const { getRadioProps, getRootProps } = useRadioGroup({
    onChange: (value) => onChange && onChange([value]),
    value,
    name,
  })

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const scenario = useSelector(selectScenario)
  const [scenarioNavType, setScenarioNavType] = useState('mobile')

  useEffect(() => {
    const province = getCookie('province')
    const stepQCookie = getCookie('stepQ')

    if (province && stepQCookie && stepQCookie === 'yes') {
      dispatch(
        addAnswer({
          stepId: Steps.PROVINCE,
          answerIds: [province],
          hidden: true,
        }),
      )
    }
  }, [])

  useEffect(() => {
    if (scenario?.initialInformation?.nav === 'mobile') {
      setScenarioNavType('mobile')
    } else if (scenario?.initialInformation?.nav === 'internet') {
      setScenarioNavType('internet')
    }
  }, [])

  return (
    <Box>
      <Box
        minWidth={500}
        padding={4}
        border={2}
        borderStyle="solid"
        borderColor="grey"
        borderRadius="xl"
        margin={4}
        boxShadow="lg"
      >
        <Text fontSize="sm" fontWeight="bold" color="green.500">
          {scenario?.initialInformation?.planName || 'Undefined'}
        </Text>
        <Box paddingX={6} paddingY={4}>
          <Grid templateColumns="repeat(2, auto)" gap={2}>
            {scenarioNavType === 'internet' ? (
              <>
                <Box>{t('download-speed')}:</Box>
                <Box textAlign="right" fontWeight="bold">
                  {scenario?.initialInformation?.downloadSpeed || 'Undefined'}
                  {t('common_mbps')}
                </Box>
                <Box>{t('monthly-data-usage')}:</Box>
                <Box textAlign="right" fontWeight="bold">
                  {scenario?.initialInformation?.planDataUsage || 'Undefined'}
                </Box>
              </>
            ) : (
              <>
                <Box>{t('voice_amount')}:</Box>
                <Box textAlign="right" fontWeight="bold">
                  {scenario?.initialInformation?.sr_voice || 'Undefined'}
                </Box>
                <Box>{t('data_amount')}:</Box>
                <Box textAlign="right" fontWeight="bold">
                  {scenario?.initialInformation?.sr_data?.replace(/[ \n]+/g, ' ') || 'Undefined'}
                </Box>
              </>
            )}
            <Box>{t('upfront')}:</Box>
            <Box textAlign="right" fontWeight="bold">
              {scenario?.initialInformation?.planUpfrontPrice || 'Undefined'}
            </Box>
            <Box>{t('monthly')}:</Box>
            <Box textAlign="right" fontWeight="bold">
              {scenario?.initialInformation?.planMonthlyPrice || 'Undefined'}
            </Box>
          </Grid>
        </Box>
      </Box>
      <HStack {...getRootProps()} justifyContent="center" margin="2vh">
        {choices.map((props) => (
          <Component key={`choice-${props.value}`} {...getRadioProps({ value: props.value })} {...props} />
        ))}
      </HStack>
    </Box>
  )
}
